<template>
  <layout-main-inner
    v-loading="loading"
    title="证书生成">
    <el-dropdown slot="action">
      <el-button
        type="primary"
        style="margin-left: 10px">
        批量操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="downloadtemplate">下载模板</el-dropdown-item>
        <el-dropdown-item @click.native="addbatchtask">批量上传</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <upload-status-select v-model="config.status" />
        <el-button
          style="margin-left: 10px;"
          type="primary"
          @click="handleCurrentChange(1)">刷新</el-button>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="原始文件"
          min-width="200"
          prop="applyName"></el-table-column>
        <el-table-column
          min-width="80"
          label="证书总数"
          prop="total"></el-table-column>
        <el-table-column
          min-width="90"
          label="导入成功数"
          prop="successfulCount"></el-table-column>
        <el-table-column
          min-width="90"
          label="导入失败数"
          prop="failedCount"></el-table-column>
        <el-table-column
          min-width="90"
          label="图片导入数"
          prop="attachImageCount"></el-table-column>
        <el-table-column
          label="证书导入状态"
          min-width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.status | orderUploadStatusType1()">{{ row.status | orderUploadStatusName1() }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="150">
          <template slot-scope="{ row }">{{ row.createdTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="完成时间"
          width="150">
          <template slot-scope="{ row }">{{ row.doneTime | dateformat() }}</template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="130">
          <template slot-scope="{ row }">
            <el-button
              :disabled="row.status !== 0"
              type="text"
              style="margin-right: 10px"
              @click="cancelcardapplyfile(row)">取消任务</el-button>
            <el-dropdown>
              <el-button type="text">
                更多<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="deleteFile(row)">删除任务</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status !== 1"
                  @click.native="uploadImageFile(row)">上传图片文件（压缩包）</el-dropdown-item>
                <el-dropdown-item @click.native="downApplyDetail(row.applyFileUrl)">下载原始文件</el-dropdown-item>
                <el-dropdown-item
                  :disabled="row.status === 0"
                  @click.native="downResultDetail(row.resultFileUrl)">下载结果文件</el-dropdown-item>
                <el-dropdown-item
                  :disabled="!(row.status === 7 && row.attachImageCount === row.total)"
                  @click.native="downPdf(row)">下载打印文件</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        slot="footer"
        background
        :current-page.sync="config.pageNum"
        :page-size="config.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        @current-change="handleCurrentChange"></el-pagination>
    </layout-card-wrap>
    <upload-new
      ref="uploadNew"
      :accept="uploadAccept" />
  </layout-main-inner>
</template>
<script>
import UploadNew from '../../components/upload-new.vue'
import UploadStatusSelect from './busi/upload-status-select.vue'
import { downloadBlobFile } from '@/utils/index'
export default {
  name: 'QualificationCertificate',
  components: { UploadNew, UploadStatusSelect },
  data() {
    return {
      uploadAccept: '',
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, examName: '', status: null }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    downApplyDetail(url) {
      window.open(url)
    },
    downResultDetail(url) {
      window.open(url)
    },
    downPdf(row) {
      this.$$JewelsApi.downloadcertfiles({ id: row.id })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    downloadtemplate() {
      this.$$JewelsApi.downloadtemplate({ })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    addbatchtask() {
      this.uploadAccept = '.xlsx,.xls'
      this.$refs.uploadNew.upload({ }, (formData) => {
        this.loading = true
        this.$$JewelsApi.addbatchtask(formData)
          .then(res => {
            console.log(res)
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.fetchList()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            console.log(err)
            this.loading = false
            this.$message.error(err.message)
          })
      })
    },
    deleteFile(row) {
      this.$confirm('是否删除任务？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$JewelsApi.deletebatchtask({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    cancelcardapplyfile(row) {
      this.$confirm('是否取消任务？', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          this.$$JewelsApi.cancelbatchtask({ id: row.id })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success('取消成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    uploadImageFile(row) {
      this.uploadAccept = '.zip,.rar'
      this.$refs.uploadNew.upload({ id: row.id }, (formData) => {
        this.loading = true
        this.$$JewelsApi.attachimage(formData)
          .then(res => {
            this.loading = false
            const { result, message } = res.data
            if ([0].includes(result)) {
              this.$message.success('上传成功')
              this.fetchList()
            } else {
              this.$message.error(message)
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.message)
          })
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$$JewelsApi.getbatchtasks(this.config)
        .then(res => {
          this.loading = false
          const { result, message, records, total } = res.data
          if ([0, 13].includes(result)) {
            this.loading = false
            this.total = total
            this.list = records.map(i => ({ ...i, applyName: i.applyFileUrl.split('originalfilename')[1].slice(1) }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
